import { CaseNoteResponse, SystemDropdownCategory } from "@/api";
import { useSystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";

/**
 * How a case note (Aktenvermerk) is named everywhere it is shown: the attached document's file name
 * for document-backed notes, otherwise the label of the type key the note stores. Empty for no note
 * and for a note carrying neither, so a caller that needs a placeholder can fall back on it.
 */
export function useCaseNoteLabel(caseNote: CaseNoteResponse | null | undefined): string {
  const { labelOf } = useSystemDropdownOptions(SystemDropdownCategory.CaseNoteType);

  return caseNote?.attachedDocument?.fileName ?? labelOf(caseNote?.type);
}
